import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import SidePanel from './SidePanel';

const Layout = ({status}) => {
  return (
    <div style={{display: 'flex',
                 flexDirection: 'column',
                 height: '100vh',
                 fontFamily: 'Schibsted Grotesk, sans-serif',
                }}>

      <Header/>

      <div style={{ display: 'flex',
                    flexDirection: 'row',
                    backgroundColor: 'black',
                    height: '100%',
                    width: '100%',
                    overflow: 'hidden',
                  }}>
        <div style={{width: '300px',
                    }}>
          <SidePanel status={status} />
        </div>

        <div style={{flex: 1,
                     display: 'flex',
                     flexDirection: 'column',
                     padding: '20px',
                     color: 'white',
                     boxSizing: 'border-box',
                    }}>
          <Outlet/>
        </div>
      </div>
    </div>
  );
};

export default Layout;
